// redux/rootSaga.ts

import { all } from 'redux-saga/effects';

import watchClientConfigurationSaga from './clientConfiguration/clientConfigurationSaga';
import { watchCommentsSaga } from './comments/commentsSaga';
import watchCustomersSaga from './customers/customersSaga';
import watchDestPointSaga from './destPoint/destPointSaga';
import watchDriversSaga from './drivers/driversSaga';
import { watchHistorySaga } from './history/historySaga';
import { watchIdentitySaga } from './identity/identitySaga';
import { watchIVAZSaga } from './ivaz/ivazSaga';
import watchProductsSaga from './products/productsSaga';
import { watchReportsSaga } from './reports/reportsSaga';
import watchResultsaga from './results/resultsSaga';
import { watchToastSaga } from './toast/toastSaga';
import watchVehiclesSaga from './vehicles/vehiclesSaga';
import watchWeightingsSaga from './weightings/weightingsSaga';

export default function* rootSaga() {
 yield all([
  watchIdentitySaga(),
  watchResultsaga(),
  watchToastSaga(),
  watchClientConfigurationSaga(),
  watchReportsSaga(),
  watchCommentsSaga(),
  watchIVAZSaga(),
  watchHistorySaga(),
  watchCustomersSaga(),
  watchDriversSaga(),
  watchVehiclesSaga(),
  watchWeightingsSaga(),
  watchProductsSaga(),
  watchDestPointSaga(),
 ]);
}
